export default __webpack_public_path__ + "static/media/delete-icon.f097edc4.svg";